import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ComponentType} from "../../../../_models/component-type";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {ApiService} from "../../../../services/api/api.service";
import {ComponentModelUploadDataService} from "../component-model-upload-data.service";
import {sortBy} from "lodash-es";
import {
    SelectSearchComponentComponent
} from "../../../../components/select-search-api/single/select-search-component.component";

@Component({
    selector: 'component-model-upload-select-component-type',
    templateUrl: './component-model-upload-select-component-type.component.html',
    imports: [
        SelectSearchComponentComponent
    ],
    styleUrls: ['../extract-component-options.component.less']
})
export class ComponentModelUploadSelectComponentTypeComponent implements OnInit, OnDestroy {
    private readonly onDestroy = new Subject<void>();

    component_types: ComponentType[] = [];
    componentTypeID: string;

    @Input() readonly = false;
    @Output() componentTypeIDChange = new EventEmitter<string>();
    compare_component: (a, b) => boolean;

    constructor(private api: ApiService,
                public dataService: ComponentModelUploadDataService) {
        this.compare_component = (a, b) => {
            return a === b;
        };
    }

    ngOnInit(): void {
        this.dataService.component_type_id$.pipe(takeUntil(this.onDestroy)).subscribe(type_id => {
            this.componentTypeID = type_id;
        });
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.unsubscribe();
    }

    setComponentType(component_type_id: string) {
        this.dataService.changeComponentType(component_type_id);
        this.componentTypeID = component_type_id;
        this.componentTypeIDChange.next(component_type_id);
    }
}
